module.exports = __webpack_public_path__ + "static/media/no.b7a21f54.svg";